<div class="d-flex flex-wrap gap-2 align-items-center mb-2">
    <ng-container *ngFor="let filter of activeFilters">
        <span class="chip">
            {{ filter.value | titlecase }}
            <span class="remove" (click)="onRemove(filter.key)"><img src="../../../assets/images/chip-close.svg" alt="chip-close"></span>
        </span>
    </ng-container>
    <a *ngIf="activeFilters.length" class="reset-link" (click)="onClearAll()">Reset Filter</a>
</div>